import type { Color } from '../core/types.js';
import { clear } from './dom.js';

export interface ColorbarHandle {
  readonly element: HTMLElement;
  render(palette: readonly Color[], current: Color, locked: boolean): void;
  onPick(handler: (c: Color) => void): void;
}

export const buildColorbar = (): ColorbarHandle => {
  const root = document.createElement('div');
  root.className = 'color-bar';
  let pickHandler: (c: Color) => void = () => {};

  return {
    element: root,
    render(palette, current, locked) {
      clear(root);
      palette.forEach((c) => {
        const btn = document.createElement('button');
        btn.className = 'color-btn' + (c === current ? ' current' : '');
        btn.style.background = c;
        btn.setAttribute('aria-label', `Color ${c}`);
        if (c === current || locked) btn.disabled = true;
        btn.addEventListener('click', () => pickHandler(c));
        root.appendChild(btn);
      });
    },
    onPick(h) {
      pickHandler = h;
    },
  };
};
